module.exports = __webpack_public_path__ + "img/logo-124x30.fe542862.svg";